import React from "react";
import Button from "react-bootstrap/Button";
import styled from "styled-components";

//images
import FlyingNerdApple from "../assets/images/flying-nerd-apple-3-x@3x.png";

//video file
import video from "../assets/images/Ciderama2020v2.mp4";

const HawkesButton = styled(Button)`
  margin: 0 5px;
  color: black;
  padding: 15px 40px;
  background-color: #d8127d;
  font-size: 24px;
  font-family: courier new;
  font-weight: bold;
  letter-spacing: 1px;
  border: solid 4px black;
  box-shadow: 7px 7px 7px rgba(0, 0, 0, 0.7);
  transition: 0.3s;
  &:hover {
    background-color: black;
    color: white;
    transform: translate(-3px, -3px);
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.4);
    border: solid 4px black;
  }
  &:active {
    transform: translate(3px, 3px);
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 1);
    background-color: black !important;
    border: solid 4px black !important;
  }
  @media (max-width: 992px) {
    width: 100%;
    margin: 10px 0;
  }
`;

const VideoPlayerContainer = styled.div`
  position: relative;
`;

const ButtonContainer = styled.div`
  padding: 30px 0 0 0;
`;

const VideoPlayerSection = styled.section`
  padding: 30px;
`;

const MobileImage = styled.img`
  height: ${props => props.height || "100px"};
  width: ${props => props.width || "100px"};
  object-fit: contain;
  margin: ${props => props.margin || "0"};
  @media (min-width: 992px) {
    display: none;
  }
`;

const VideoSection = ({ findOutMoreOnClick }) => (
  <VideoPlayerSection>
    <VideoPlayerContainer>
      <video
        width="100%"
        height="100%"
        preload="auto"
        controls
        style={{ backgroundColor: "#d8d8d8" }}
      >
        <source src={video} type="video/mp4" />
      </video>
    </VideoPlayerContainer>
    <ButtonContainer>
      <HawkesButton
        onClick={() =>
          (window.location =
            "https://www.designmynight.com/london/whats-on/festival/ciderama-festival")
        }
      >
        BUY TICKETS
      </HawkesButton>
      <HawkesButton onClick={findOutMoreOnClick}>FIND OUT MORE</HawkesButton>
    </ButtonContainer>
    <MobileImage
      src={FlyingNerdApple}
      width="230px"
      height="130px"
      margin="40px 0 40px 0"
    />
  </VideoPlayerSection>
);

export default VideoSection;
